export default {
    getActiveScenario(state) {
        return state.activeScenario;
    },

    getActiveScenarioData(state) {
        return state.activeScenarioData;
    },

    getScenarioIndicators(state) {
        return state.scenarioIndicators;
    },

    getScenarioActiveChild(state) {
        return state.scenarioActiveChild;
    },

    getScenarioActiveAdult(state) {
        return state.scenarioActiveAdult;
    },
}
